import { gql } from "@apollo/client";

const SAVE_ALMACENAMIENTO_PRESENCIAL_AE = gql`
    mutation saveVisitaPresencialAEAlmacenamiento($input: AddVisitaPresencialAEAlmacenamientoInput!){
        saveVisitaPresencialAEAlmacenamiento(input: $input) {
            idPresencialAE
            idVisita
        }
    }
`;

export default SAVE_ALMACENAMIENTO_PRESENCIAL_AE;

export const adaptAddVisitaPresencialAEAlmacenamientoInput = (data) => ({
  idPresencialAE: data?.idPresencialAE,
  condicionAlmacenamiento: !!data?.condicionAlmacenamiento,
  obsCondicionAlmacenamiento: data?.obsCondicionAlmacenamiento,
  stockProductos: !!data?.stockProductos,
  obsStockProductos: data?.obsStockProductos,
  listResultadoPH: data?.listResultadoPH || [],
  solicitaRXControl: !!data?.solicitaRXControl,
  observaciones: data?.observaciones

});